export default __webpack_public_path__ + "static/media/dentist.48888350.png";